import './App.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';


import Home from "./screens/Home";

function App() {
  return (
    <Home />
  );
}

export default App;
